<template>
    <Trombinoscope 
      baseRoute="/portfolio/audiovisuel"
      Title="Audiovisuel"
      :projects="audiovisualProjects"
    />
</template>






<script>


import Trombinoscope from '@/components/Trombinoscope.vue';




export default {
  components:{
    Trombinoscope
  },
  data() {
    return {
      audiovisualProjects: [
        {
          nom: 'Digital Detox',
          description: "Vidéo sur la détox digitale",
          background: '/img/projet/digitaldetox.jpg',
          date:"Avril 2024 ",
          skills:["premierepro.png"]
        },
        { 
          nom: "Scène d'épouvante",
           description: 'Vidéo épouvante réalisé avec la caméra 3D sur after effects', 
           background: '/img/projet/epouvante.jpg' ,
           date:'Novembre 2024',
           skills:["aftereffects.png","photoshop.png"]
          },
          {
          nom: 'New World Symphony',
           description: 'Clip audiovisuel', 
           background: '/img/projet/clip.jpg',
           date:'Juin 2024',
           skills:["premierepro.png","canva.png"]
          },
          {
          nom: 'Les Arènes',
           description: "Vidéo sur les Arènes d'Évry-Courcouronnes", 
           background: '/img/projet/lesArenes.jpg',
           date:'Novembre 2024',
           skills:["premierepro.png"]
          },
          {
          nom: 'Player',
           description: "Reproduction d'un player audio", 
           background: '/img/projet/player.jpg',
           date:"Octobre 2024",
           skills:["/aftereffects.png","illustrator.png"]
          },
          { 
          nom: 'Générique',
           description: 'Générique de fin de comédie romantique', 
           background: '/img/projet/generique.jpg',
           date:"Janvier 2025",
           skills:["/aftereffects.png"]
          },
          { 
           nom: 'Expérience 360',
           description: 'Expérience 360 interactive', 
           background: '/img/projet/experience360.jpg',
           date:"Avril 2025",
           skills:["/sphere.png"]
          },
          {
          nom: 'Scénario 360',
           description: 'Court-métrage basé sur un scénario 360', 
           background: '/img/projet/scenario360.jpg',
           date:"Janvier 2025",
           skills:["/premierepro.png"]
          },
          {
           nom: 'Génome',
           description: "Vidéo d'analyse de génome sur After Effects", 
           background: '/img/projet/genome.jpg',
           date:"Avril 2025",
           skills:["/aftereffects.png",'/illustrator.png']
          },
          { 
          nom: 'Carte de voeux',
           description: 'Carte de voeux pour la nouvelle année sur after effects', 
           background: '/img/projet/carteDeVoeux.jpg',
           date:"Janvier 2025",
           skills:["/aftereffects.png"]
          },
          { 
          nom: 'Je filme ma formation',
           description: 'Vidéo de présentation de la formation MMI', 
           background: '/img/projet/jeFilmeMaFormation.jpg',
           date:"Janvier 2025",
           skills:["/premierepro.png"]
          },
          { 
          nom: 'Entretien étudiant',
           description: "Montage de l'entretien d'un étudiant en MMI sur le thème du numérique", 
           background: '/img/projet/entretien.jpg',
           date:"Octobre 2025",
           skills:["/premierepro.png"]
          },
          { 
          nom: 'Micro-trottoir',
           description: "Montage du micro-trottoir d'un sénior sur le thème du numérique", 
           background: '/img/projet/microTrottoir.jpg',
           date:"Janvier 2026",
           skills:["/premierepro.png"]
          },
          { 
          nom: 'Impasse',
           description: "Court-métrage de l'association Next.Us", 
           background: '/img/projet/impasse.jpg',
           date:"Mars 2026",
           skills:["/premierepro.png","aftereffects.png"],
          },
      ],
    };
  },
};


</script>




<style scoped>

</style>